import Cutout from "./cutout";
import Joint from "./joint";

export default class JointFile {
    static async fetchSample(path: string): Promise<JointFile> {
        const response = await fetch(`/samples/jobs/${path}`);
        if (!response.ok) {
            throw new Error(`Sample ${path} not found!`);
        }

        const raw = await response.text();

        let jf = new JointFile(path, raw);
        jf.joints = JointFile.parse(jf.raw);
        return jf;
    }

    static async load(file: File): Promise<JointFile> {
        const raw = await file.text();

        let jf = new JointFile(file.name, raw);
        jf.joints = JointFile.parse(jf.raw);
        return jf;
    }

    constructor(fileName: string, raw: string) {
        this.fileName = fileName;
        this.raw = raw;
    }

    fileName: string;
    raw: string;
    joints: Joint[] = [];

    static parse(contents: string): Joint[] {
        const joints = [];
        let joint = null;

        const lines = contents.split(/\r?\n/);
        for (let i = 0; i < lines.length; i++) {
            let fields = lines[i].split(',');

            if (fields.length === 24) {
                let newJoint = new Joint(fields);
                if (newJoint.quantity >= 0) {
                    joint = newJoint;
                    joints.push(joint);
                }
                else {
                    console.warn('Invalid joint', fields, newJoint);
                }
            }
            else if (fields.length === 5) {
                let cutout = new Cutout(fields);
                if (joint == null) {
                    console.warn('CUTOUT found before joint', cutout);
                }
                else if (cutout.type >= 0) {
                    joint.cutouts.push(cutout);
                }
                else {
                    console.warn('Invalid cutout', fields, cutout);
                }
            }
        }

        return joints;
    }
}
